/* Keeps the 2.0 buy-box tier cards (.qs-card) in step with the A/B Quantity Breaks app.
   The app (app embed) publishes window.omgQuantityData on every page and also renders its own
   widget (.omg-option-item). Prices, strike prices and % off on our cards are filled from the
   app, so a price change in the app shows here with no theme edit. The text typed into the
   template's bundle blocks stays as the fallback when the app data is missing.
   Order of trust: 1) the app's rendered widget (reflects any A/B the app is running),
   2) the offer data for this product, 3) the typed fallback. */
(function () {
  'use strict';
  var wrap = document.getElementById('pdp-bundles');
  if (!wrap) return;
  var productId = String(wrap.getAttribute('data-product-id') || '');
  var unitCents = parseInt(wrap.getAttribute('data-price-cents'), 10) || 0;
  var cards = Array.prototype.slice.call(wrap.querySelectorAll('.qs-card[data-qty]'));
  if (!cards.length) return;

  function baht(n) { return '฿' + Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function num(t) { var d = String(t || '').replace(/[^\d.]/g, ''); return d ? parseFloat(d) : 0; }

  // qty -> {price, strike} from the app's own rendered widget
  function fromWidget() {
    var out = {};
    document.querySelectorAll('.omg-option-item').forEach(function (it) {
      var q = parseInt((it.textContent || '').replace(/^\s+/, ''), 10);
      var price = num((it.querySelector('.omg-money-discount') || {}).textContent);
      var strike = num((it.querySelector('.omg-money-origin') || {}).textContent);
      if (q > 0 && price > 0) out[q] = { price: price, strike: strike };
    });
    return out;
  }

  // qty -> {price, strike} computed from the offer rules for this product
  function fromData() {
    var out = {}, d = window.omgQuantityData;
    if (!d || !d.offers || !productId || !unitCents) return out;
    var offer = null;
    d.offers.forEach(function (o) {
      if (offer || String(o.status) !== '1') return;
      if ((o.product_list || []).map(String).indexOf(productId) !== -1) offer = o;
    });
    if (!offer || !offer.discount_rule) return out;
    var unit = unitCents / 100;
    cards.forEach(function (c) {
      var q = parseInt(c.getAttribute('data-qty'), 10); if (!(q > 0)) return;
      var rule = null;
      offer.discount_rule.forEach(function (r) {
        var from = parseInt(r.buy_from, 10) || 0;
        if (from <= q && (!rule || from > (parseInt(rule.buy_from, 10) || 0))) rule = r;
      });
      if (!rule) return;
      var v = parseFloat(rule.discount_value) || 0, each;
      if (rule.discount_unit === 'fixed') {
        each = (rule.discount_type === 'per_item') ? v : null;
        if (each === null) { out[q] = { price: Math.max(0, unit * q - v), strike: unit * q }; return; }
      } else if (rule.discount_unit === 'percent' || rule.discount_unit === 'percentage') {
        each = unit * (1 - v / 100);
      } else { return; }
      out[q] = { price: each * q, strike: unit * q };
    });
    return out;
  }

  function apply() {
    var w = fromWidget(), d = fromData(), changed = false;
    cards.forEach(function (c) {
      var q = parseInt(c.getAttribute('data-qty'), 10);
      var t = w[q] || d[q]; if (!t || !(t.price > 0)) return;
      var strike = t.strike > 0 ? t.strike : (unitCents / 100) * q;
      var priceEl = c.querySelector('.qs-price'), strikeEl = c.querySelector('.qs-strike'), offEl = c.querySelector('.qs-off');
      var p = baht(t.price);
      if (priceEl && priceEl.textContent !== p) { priceEl.textContent = p; changed = true; }
      if (strikeEl && strike > t.price) { var s = baht(strike); if (strikeEl.textContent !== s) strikeEl.textContent = s; }
      if (offEl && strike > t.price) {
        var pct = Math.round((strike - t.price) / strike * 100);
        var cur = offEl.textContent || '';
        var next = /\d+/.test(cur) ? cur.replace(/\d+/, String(pct)) : (pct + '% OFF');
        if (cur !== next) offEl.textContent = next;
      }
      c.setAttribute('data-qb-synced', w[q] ? 'widget' : 'data');
    });
    return changed;
  }

  apply();
  // The app's script and widget load after us: keep re-applying for a while, then on any change.
  var tries = 0, iv = setInterval(function () { apply(); if (++tries > 40) clearInterval(iv); }, 250);
  if (window.MutationObserver) {
    var pending = false;
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var n = muts[i].target;
        if (n && n.nodeType === 1 && n.closest && n.closest('#pdp-bundles')) continue; // ignore our own writes
        if (!pending) { pending = true; setTimeout(function () { pending = false; apply(); }, 150); }
        return;
      }
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }
})();
